import appConfig from '../../appConfig';

import {MORIA_COMPONENTS, MORIA_DESKTOP_PARTIALS_LIST} from './moriaComponentsConstants';
import {
  DESKTOP_COMPONENTS,
  DESKTOP_COMPONENTS_OPTIONS,
  MOBILE_COMPONENTS,
  MOBILE_COMPONENTS_OPTIONS
} from '../voltran/voltranConstants';

class MoriaComponentsHelper {
  static getProductListData(data){
    return data?.[MORIA_COMPONENTS.PRODUCT_LIST] || []
  }

  static getSeoState(data){
    const productList = this.getProductListData(data);
    return productList?.seoState || {}
  }

  static getTotalProductCount(data){
    return this.getSeoState(data)?.totalProductCount || 0;
  }

  static getRedirection(data) {
    const productList = this.getProductListData(data);
    return productList.redirection || {}
  }

  static getPageData(data) {
    const productList = this.getProductListData(data);
    return productList.pageData || {}
  }

  static getDesktopComponents(data, componentName) {
    const moriaComponents = data?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.MORIA_LISTING]?.id?.toString());
    return moriaComponents?.[componentName] || null;
  }

  static getMobileComponents(data, componentName) {
    const moriaComponents = data?.get(MOBILE_COMPONENTS_OPTIONS[MOBILE_COMPONENTS.MORIA_LISTING]?.id?.toString());
    return moriaComponents?.[componentName] || null;
  }

  static getMoriaRequestUrl({suffix, excludedPartials = []}) {
    let partials = MORIA_DESKTOP_PARTIALS_LIST;

    if (excludedPartials?.length > 0) {
      partials = partials?.filter(partial => !excludedPartials?.includes(partial));
    }

    const partialsUrl = `/components/${partials?.join(',')}`;

    return {
      serverUrl: `${appConfig.moriaApi.serverUrl}${partialsUrl}${suffix}`,
      clientUrl: `${appConfig.moriaApi.clientUrl}${partialsUrl}${suffix}`,
    };
  }

  static getFacetBoostedValues(data, facetKey, boostType) {
    const seoState = this.getSeoState(data);

    const facetBoostedValues = seoState?.boostedFacets?.find(bf => bf.attribute == facetKey);
    if (!facetBoostedValues?.values?.length) return [];

    return facetBoostedValues.values.filter(bv => bv.boostType == boostType);
  }

  static getBrandTopPopulerValues(data) {
    const brandTopPopulerFilterBoostedFacetValues = this.getFacetBoostedValues(data, 'Brand', 'TopPopularFilterValue');
    return brandTopPopulerFilterBoostedFacetValues?.map(item => item.displayName) ?? [];
  }
}

export default MoriaComponentsHelper;
